module.exports = __webpack_public_path__ + "register/img/membership-premium.97be57d7.svg";